<template>
  <el-card>
    <template #header>
      <h4>{{$t('到期积分规则')}}</h4>
    </template>

   <div style="height: 500px">
     <table-list ref="list" :on-page="false" @query="loadRule" :data="ruleList" :show-page="false" :height="500">
       <el-table-column type="index" width="50" :label="$t('序号')"/>
       <el-table-column prop="day" :label="$t('会员到期/天')"/>
       <el-table-column prop="integral" :label="$t('积分数（掉）')"/>
       <el-table-column prop="band" :label="$t('状态')">
         <template v-slot="{row}">
           <dict-text :status="row.status" dict-flag="EXPIRE_POINTS_RULE"/>
         </template>
       </el-table-column>
       <el-table-column prop="createTimeStr" :label="$t('创建时间')"/>
       <el-table-column :label="$t('操作')">
         <template v-slot="{row}">
           <div class="fb-link-flex">
             <el-link :underline="false" type="primary" @click="handleEditRow(row)">{{$t('编辑')}}</el-link>
             <el-link :underline="false" type="primary" @click="handleChangeStatus(row)">
               {{ row.status === "open" ? $t('禁用') : $t('启用') }}
             </el-link>
           </div>
         </template>
       </el-table-column>
     </table-list>
   </div>


    <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleResetForm">
      <template #title>
        <h4>{{$t('到期积分规则编辑')}}</h4>
      </template>

      <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
        <el-form-item :label="$t('会员到期/天')" prop="day">
          <el-input :placeholder="$t('会员到期/天')" v-model="formData.day"/>
        </el-form-item>
        <el-form-item :label="$t('积分数（掉）')" prop="integral">
          <el-input :placeholder="$t('积分数（掉）')" v-model="formData.integral"/>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button type="primary" @click="handleSubmit">{{$t('确定')}}</el-button>
        <el-button @click="showDialog = false">{{$t('取消')}}</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import {resetEmpty} from "@/utils/common";
import DictText from "@/components/dict/DictText";

export default {
  name: "IntegralRule",
  components: {DictText, TableList},
  data() {
    return {
      ruleList: [],
      showDialog: false,
      formData: {
        day: null,
        integral: null,
        code: null,
        status: null,
      },
      rules: {
        day: {required: true, message: this.$t('请输入会员到期/天'), trigger: 'blur'},
        integral: {required: true, message: this.$t('请输入积分数（掉）'), trigger: 'blur'},
      }
    }
  },
  methods: {
    // 更改状态
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "open" ? "band" : "open"
        }
        await request(this.$api.vipExpireRule.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 提交
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        try {
          await request(this.$api.vipExpireRule.update, this.formData);
          this.$message.success(this.$t('操作成功'));
          this.$refs.list.handleRequest();
          this.showDialog = false;
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 重置表单
    handleResetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    },

    // 编辑
    handleEditRow(row) {
      for (let key in this.formData) {
        this.formData[key] = row[key];
      }
      this.showDialog = true;
    },

    // 加载到期规则
    async loadRule(params) {
      try {
        const res = await request(this.$api.vipExpireRule.list, params);
        this.ruleList = res.vipExpireRules.map(item => {
          item.createTimeStr = this.$moment(item.createTime).format('YYYY-MM-DD HH:mm:ss');
          return item;
        })
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
